module.exports = __webpack_public_path__ + "img/three.af09a3e7.png";